export function Lerp(a: number, b: number, t: number) {
    return a + (b - a) * t;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/math/lerp.ts